<script lang="ts">
  import moneyFormatters from "@shared/filters/money.js";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  export let productId: number;
  export let carrierDeposit: number;

  const carrierDepositRolloutEnabled = stagedRolloutCheck("carrier_deposits_rollout");

  $: formattedTotalCarrierDeposit = moneyFormatters.filter()(carrierDeposit).replace(/\.00$/, "");
</script>

<style>
  .fizz-tooltip-trigger {
    border-bottom: 1px dashed currentColor;
    font-weight: inherit;
  }
</style>

{#if carrierDepositRolloutEnabled && carrierDeposit}
  <div
    class="fizz-tooltip-container fizz-flex-row-4 fizz-text-subdued fizz-text-small fizz-align-content-start"
    data-testid="carrier-deposit-string"
  >
    <Icon type="CreditsColor" fill="#595959" height="20" width="12" />
    <p
      class="fizz-tooltip-trigger fizz-underline-dashed"
      aria-describedby="tooltip-carrier-deposit-{productId}"
    >
      {formattedTotalCarrierDeposit} carrier deposit
    </p>
    <div
      class="fizz-tooltip"
      role="tooltip"
      style="--max-width: 190px;"
      id="tooltip-carrier-deposit-{productId}"
    >
      {formattedTotalCarrierDeposit} carrier deposit applied on final invoice
    </div>
  </div>
{/if}
